<template>
  <bdg-input-template
    class="bdg-date-field"
    :name="name"
    :invalid="isInvalid"
    :required="required"
    @focusout="onFocusout"
  >
    <functional-calendar
      ref="datepicker"
      class="w-full"
      :placeholder="placeholder"
      :date-format="dateFormat"
      :is-multiple-date-picker="multiple"
      :is-date-picker="!multiple"
      is-modal
      sunday-start
      v-model="computedValue"
    />
  </bdg-input-template>
</template>

<script>
import BdgInputTemplate from "./BdgInputTemplate";
import { FunctionalCalendar } from "vue-functional-calendar";

export default {
  name: "BdgDateField",
  extends: BdgInputTemplate,
  components: { FunctionalCalendar, BdgInputTemplate },
  props: {
    value: [String, Array],
    placeholder: String,
    multiple: Boolean
  },
  data() {
    return {
      dateFormat: "mm/dd/yyyy",
      baseValueObject: {
        dateRange: { start: "", end: "" },
        multipleDateRange: [],
        selectedDate: "",
        selectedDateTime: false,
        selectedDates: [],
        selectedDatesItem: "",
        selectedHour: "00",
        selectedMinute: "00"
      }
    };
  },
  computed: {
    computedValue: {
      get() {
        if (this.multiple) {
          // return { selectedDates: ["09/01/2020"], selectedDate: false, selectedDateTime: false };
          const selectedDates =
            this.value && Array.isArray(this.value)
              ? this.value.map(d => {
                  return d
                    ? {
                        date: this.$moment(d, [
                          "YYYY-MM-DD HH:mm:ss",
                          "M/D/YYYY"
                        ]).format("M/D/YYYY")
                      }
                    : null;
                })
              : [];

          return {
            ...this.baseValueObject,
            selectedDates
          };
        }

        return {
          ...this.baseValueObject,
          selectedDate: this.value
            ? this.$moment(this.value, [
                "YYYY-MM-DD HH:mm:ss",
                "M/D/YYYY"
              ]).format("M/D/YYYY")
            : null
        };
      },
      set(val) {
        let emittedValue = null;
        if (this.multiple) {
          emittedValue =
            val && val.selectedDates && val.selectedDates.length
              ? val.selectedDates.map(
                  d => this.$moment(d.date).format("YYYY-MM-DD") + " 00:00:00"
                )
              : [];
        } else if (val && val.selectedDate) {
          emittedValue =
            this.$moment(val.selectedDate).format("YYYY-MM-DD") + " 00:00:00";
        }

        this.$emit("input", emittedValue);
      }
    },
    isValid() {
      if (this.multiple) {
        return (
          this.computedValue &&
          this.computedValue.selectedDates &&
          this.computedValue.selectedDates.length > 0
        );
      }

      return (
        this.computedValue &&
        this.computedValue.selectedDate &&
        this.computedValue.selectedDate.length > 0
      );
    }
  },
  methods: {
    onFocusout() {
      this.isInvalid = this.required && !this.isValid;
    }
  }
};
</script>

<style scoped></style>
